import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EidErrors } from '../enums/eid-errors.enum';
import { CustomToastersService, RouteHelperService } from '@app/shared/services';
import { EidAuthService } from '../services/eid-auth.service';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  templateUrl: './eid-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EidCallbackComponent implements OnInit {
  constructor(
    private readonly eidAuthService: EidAuthService,
    private readonly customToasters: CustomToastersService,
    private route: ActivatedRoute,
    private readonly routeHelper: RouteHelperService
  ) {}

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async (params) => {
      if (!params.code) {
        this.customToasters.customError(EidErrors.noCodeOrToken);
        this.routeHelper.login();
      } else {
        try {
          const user = await firstValueFrom(this.eidAuthService.checkAuth());
          if (user) {
            this.routeHelper.redirectByUrl('/eid-loggedin');
          } else {
            this.customToasters.customError(EidErrors.noCodeOrToken);
            this.routeHelper.login();
          }
        } catch (error) {
          this.customToasters.customError(EidErrors.invalidConfig);
          this.routeHelper.login();
        }
      }
    });
  }
}
